<template>
  <NuxtLayout name="sticky">
    <template #header>
      <slot name="header" />
    </template>

    <LcTabs
      v-bind="{
        tabs,
        value,
      }"
      :render-only-visible="false"
      trigger="manual"
      @update:value="navigateToTab"
    >
      <template #tab-panel="{ tab }">
        <component
          :is="tab.data.comp"
          v-bind="{ id, type }"
          :is-visible="tab.name === value"
          :name="tab.name"
        />
      </template>
    </LcTabs>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import type { InfoRouteType } from '~/constants/infoRoutes'

import Faq from '@/custom-pages/info/children/faq.vue'
import Prizes from '@/custom-pages/info/children/prizes.vue'
import Rules from '@/custom-pages/info/children/rules.vue'

type InfoTabData = {
  comp: typeof Faq | typeof Prizes | typeof Rules
}

type Props = {
  hideFaq?: boolean
  hidePrizes?: boolean
  hideRules?: boolean
  id: string
  type: InfoRouteType
  value: string
}

const { hideFaq = false, hidePrizes = false, hideRules = false } = defineProps<Props>()

const { t } = useI18n()
const router = useRouter()

const { activeTabs: tabs } = useTabs<InfoTabData>(
  computed(() => [
    {
      active: !hideRules,
      data: { comp: Rules },
      name: 'rules',
      title: t('info.tab.rules.title', 2),
    },
    {
      active: !hidePrizes,
      data: { comp: Prizes },
      name: 'prizes',
      title: t('info.tab.prizes.title', 2),
    },
    {
      active: !hideFaq,
      data: { comp: Faq },
      name: 'faq',
      title: t('info.tab.faq.title', 2),
    },
  ]),
)

const navigateToTab = async (id?: string) => {
  if (!id) return
  await router.replace({
    params: { ...router.currentRoute.value.params, id },
  })
}
</script>
